<div class="modal-header">
  <h5 class="modal-title" i18n>Revert to original image</h5>
  <button type="button" class="close" (click)="close()">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="revert-card">
    <div class="enhance-icons">
      <div class="enhance-icon-circle enhance-icon-original">
        <svg width="23" height="18" viewBox="0 0 23 18" fill="none">
          <path
            d="M21.1159 0H1.66705C0.747879 0 0 0.750106 0 1.67194V17.5488C0.0144192 18.1467 0.897856 18.1497 0.911164 17.5487C0.911164 17.5488 0.911164 1.67194 0.911164 1.67194C0.911164 1.2524 1.25018 0.911159 1.66705 0.911159H21.116C21.5355 0.911159 21.8767 1.2524 21.8767 1.67194V3.69002C21.8817 4.2865 22.7808 4.28936 22.7879 3.69C22.7879 3.69002 22.7879 1.67194 22.7879 1.67194C22.7879 0.750106 22.0378 0 21.1159 0Z"
            fill="#507CD6"
          />
          <path
            d="M21.877 5.51222V15.6269L18.3653 9.70164C17.904 8.88247 16.739 8.6361 15.9833 9.19715C15.9833 9.19713 14.7234 10.0925 14.7234 10.0925C14.4097 10.3154 13.9822 10.2653 13.7299 9.97771L10.4519 6.23007C9.79294 5.42976 8.44111 5.49743 7.85898 6.35735C7.85898 6.35732 5.63892 9.45273 5.63892 9.45273C5.29756 9.93994 6.02701 10.4663 6.37925 9.98392C6.37924 9.98394 8.59929 6.88875 8.59929 6.88875C8.86366 6.50094 9.46401 6.46824 9.76583 6.82982C9.76583 6.82981 13.0443 10.5779 13.0443 10.5779C13.6062 11.2192 14.5552 11.3298 15.251 10.8353L16.5105 9.94012C16.849 9.68756 17.3745 9.7959 17.581 10.1655C17.581 10.1655 21.5855 16.9224 21.5855 16.9224C21.4548 17.0252 21.2913 17.0886 21.1162 17.0886H0.733406C0.142398 17.0932 0.129109 17.9912 0.733433 17.9997C0.733406 17.9997 21.1162 17.9997 21.1162 17.9997C22.029 18.0116 22.799 17.2281 22.7881 16.3322C22.7881 16.3322 22.7881 5.51223 22.7881 5.51223C22.7881 5.26064 22.5844 5.05665 22.3325 5.05665C22.0807 5.05664 21.877 5.26063 21.877 5.51222Z"
            fill="#507CD6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.931 5.08668C17.931 6.35465 16.8993 7.38616 15.6313 7.38616C14.3633 7.38616 13.332 6.35465 13.332 5.08672C13.4394 2.04387 17.823 2.04351 17.931 5.08668ZM15.6313 3.69837C17.4622 3.74644 17.4619 6.4272 15.6312 6.475C13.801 6.42681 13.8013 3.74629 15.6313 3.69837Z"
            fill="#507CD6"
          />
        </svg>
      </div>
      <i class="far fa-undo-alt revert-arrow-icon"></i>
      <div class="enhance-icon-circle enhance-icon-enhanced">
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none">
          <path
            d="M20.4025 0H1.99929C1.12954 0 0.421875 0.709776 0.421875 1.58205V11.0011C0.435519 11.5669 1.27146 11.5698 1.28405 11.0011C1.28405 11.0011 1.28405 1.58205 1.28405 1.58205C1.28405 1.18507 1.60484 0.862169 1.99929 0.862169H20.4025C20.7995 0.862169 21.1224 1.18506 21.1224 1.58205V3.49162C21.127 4.05603 21.9778 4.05873 21.9845 3.4916C21.9845 3.49162 21.9845 1.58205 21.9845 1.58205C21.9845 0.709776 21.2748 0 20.4025 0Z"
            fill="#7D0CC9"
          />
          <path
            d="M21.1247 5.216V14.7868L17.8019 9.18017C17.3654 8.40504 16.263 8.17192 15.5479 8.7028C15.5479 8.70278 14.3557 9.55 14.3557 9.55C14.0589 9.76091 13.6544 9.71355 13.4157 9.44139L10.3139 5.89525C9.69039 5.13797 8.41125 5.202 7.86042 6.01569C7.86042 6.01566 5.75971 8.94463 5.75971 8.94463C5.43671 9.40565 6.12694 9.90367 6.46025 9.44726C6.46023 9.44729 8.56092 6.51852 8.56092 6.51852C8.81108 6.15156 9.37915 6.12062 9.66474 6.46275C9.66474 6.46274 12.767 10.0093 12.767 10.0093C13.2986 10.6161 14.1966 10.7208 14.855 10.2528L16.0468 9.40582C16.367 9.16684 16.8643 9.26936 17.0597 9.61906C17.0597 9.61905 20.8489 16.0126 20.8489 16.0126C20.7253 16.11 20.5705 16.1699 20.4048 16.1699H9.73969C9.18046 16.1743 9.16789 17.024 9.73972 17.0321C9.73969 17.0321 20.4048 17.0321 20.4048 17.0321C21.2685 17.0433 21.9972 16.302 21.9869 15.4543C21.9869 15.4543 21.9869 5.216 21.9869 5.216C21.9869 4.97794 21.7941 4.78492 21.5558 4.78492C21.3175 4.78491 21.1247 4.97793 21.1247 5.216Z"
            fill="#7D0CC9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.3907 4.81334C17.3907 6.01314 16.4145 6.98918 15.2147 6.98918C14.0149 6.98918 13.0391 6.01314 13.0391 4.81337C13.1407 1.93413 17.2886 1.93379 17.3907 4.81334ZM15.2147 3.49967C16.9472 3.54516 16.9469 6.08178 15.2147 6.12701C13.4828 6.08141 13.4831 3.54501 15.2147 3.49967Z"
            fill="#7D0CC9"
          />
          <path
            d="M5.6447 13.6107L6.03659 12.7485L6.89877 12.3566L6.03659 11.9647L5.6447 11.1025L5.2528 11.9647L4.39062 12.3566L5.2528 12.7485L5.6447 13.6107Z"
            fill="#7D0CC9"
          />
          <path
            d="M5.6447 15.4917L5.2528 16.3539L4.39062 16.7458L5.2528 17.1377L5.6447 17.9998L6.03659 17.1377L6.89877 16.7458L6.03659 16.3539L5.6447 15.4917Z"
            fill="#7D0CC9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.50814 12.0432L3.29193 13.7676L5.01628 14.5514L3.29193 15.3351L2.50814 17.0595L1.72435 15.3351L0 14.5514L1.72435 13.7676L2.50814 12.0432ZM2.50814 15.5452L2.81852 14.8617L3.50199 14.5514L2.81852 14.241L2.50814 13.5575L2.19776 14.241L1.51429 14.5514L2.19776 14.8617L2.50814 15.5452Z"
            fill="#7D0CC9"
          />
        </svg>
      </div>
    </div>

    <p class="revert-title" i18n>This will remove the enhanced version and restore the original image.</p>
    <p class="revert-description" i18n>The original image is always preserved.</p>

    <p *ngIf="error" class="revert-title text-danger mt-2">{{ error }}</p>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-light" type="button" (click)="close()" [disabled]="isReverting">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button class="btn btn-secondary-primary" type="button" (click)="revert()" [disabled]="isReverting">
    <ng-container *ngIf="!isReverting">
      <i class="far fa-undo-alt"></i> <ng-container i18n>Revert to original</ng-container>
    </ng-container>
    <ng-container *ngIf="isReverting">
      <i class="far fa-spin fa-spinner"></i> <ng-container i18n>Reverting</ng-container>...
    </ng-container>
  </button>
</div>
